import { Component } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-loader',
  imports: [NgIf],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  showLoader: boolean = false;

  constructor(
    private loader: LoaderService
  ) {
    this.loader
      .listener
      .subscribe((result: boolean) => {
        this.showLoader = result;
      })
  }
  
}
